import { useEffect } from 'react';
import { useOrganizationProfile } from '@/hoc/api/api-service';
import { getUserProfileData } from '@/utils';
import { readUserDetails, writeUserDetails } from '@/utils/auth-token-store';
// Long enough that moving between pages doesn't refetch (and re-download the logo);
// profile mutations refresh the query themselves.
const STALE_MS = 5 * 60 * 1000;
export default function useAccountIdentity() {
    const { data, dataUpdatedAt } = useOrganizationProfile({ staleTime: STALE_MS });
    const fresh = data === null || data === void 0 ? void 0 : data.data;
    const profile = fresh !== null && fresh !== void 0 ? fresh : getUserProfileData();
    useEffect(() => {
        if (!fresh)
            return;
        const value = JSON.stringify(fresh);
        if (readUserDetails() !== value)
            writeUserDetails(value);
    }, [fresh]);
    // A re-uploaded image can keep its URL; tie the cache-buster to the last refresh.
    const bust = (url) => (url && fresh ? `${url}?t=${dataUpdatedAt}` : url || undefined);
    const rep = profile === null || profile === void 0 ? void 0 : profile.representative_details;
    if (rep === null || rep === void 0 ? void 0 : rep.full_name) {
        return {
            name: rep.full_name,
            role: rep.current_designation || '',
            avatar: bust(rep.representative_image_link),
            isOrganization: false,
        };
    }
    return {
        name: (profile === null || profile === void 0 ? void 0 : profile.organization_name) || 'Organization',
        role: 'Organization',
        avatar: bust(profile === null || profile === void 0 ? void 0 : profile.organization_image_link),
        isOrganization: true,
    };
}
